export default __webpack_public_path__ + "static/media/circle_heart.99cfe2b5.svg";